const lineReader = value => {
  if (!value) {
    return []
  }

  // 先统一处理 \r\n，然后处理 \n 和 \t
  // 使用正则表达式匹配所有分隔符：\r\n、\n、\t
  const lines = value
    .split(/\r\n|\n|\t/)
    .map(line => line.trim())
    .filter(line => line.length > 0) // 过滤掉空行

  return lines
}

export default lineReader
